import { getFieldFromSlug } from "../helpers/structure";
import { Fields } from "../types/fields";
import { BaseRecord, FormConfig, FormValues } from "../types/form";
import { getFieldRegistryConfig } from "./map";

export type CollectedMetadata = FormValues & { fieldsMetadata?: Record<string, unknown> };

export function convertFormValueToApi<FormValue, FieldValue>(
  value: FormValue,
  fieldType: Fields
): FieldValue | undefined {
  const config = getFieldRegistryConfig(fieldType);

  if (!config?.convertFormValueToApi) {
    return value as unknown as FieldValue;
  }

  return config.convertFormValueToApi(value) as FieldValue;
}

export const collectMetadata = (values: FormValues): CollectedMetadata => {
  const result: Record<string, unknown> = {};
  const fieldsMetadata: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(values)) {
    if (key.startsWith("metadata_")) {
      const fieldKey = key.replace("metadata_", "");
      fieldsMetadata[fieldKey] = value;
    } else {
      result[key] = value;
    }
  }

  if (Object.keys(fieldsMetadata).length > 0) {
    result.fieldsMetadata = fieldsMetadata;
  }

  return result as CollectedMetadata;
};

/**
 * Converts a form values object to a valid record object expected by SmartSuite API.
 */
export function convertFormValuesToApi(values: FormValues, config: FormConfig): BaseRecord {
  const { fieldsMetadata, ...rest } = collectMetadata(values);

  return Object.entries(rest).reduce(
    (record, [slug, value]) => {
      if (value?.shouldSkip) {
        return { ...record };
      }
      const field = getFieldFromSlug(slug, config);

      return {
        ...record,
        [slug]: convertFormValueToApi(value, field.field_type),
      };
    },
    fieldsMetadata ? { fields_metadata: fieldsMetadata } : {}
  );
}
